<template>
  <FilterPopper>
    <template #default="{ menuOpen }">
      <BaseFilterButton
        :name="label"
        :active="isActive"
        :tagValue="tagValue"
        :menuOpen="menuOpen"
      />
    </template>
    <template #popper>
      <div v-if="statusList.length > 0" class="filter-settings scrollbar">
        <div v-for="(status, index) in statusList" :key="`${status.value}-${index}`" class="filter-settings__row">
          <input
            :id="`taskStatusFilter-${status.value}-${index}`"
            v-model="selectedStatuses"
            type="checkbox"
            :name="'selected-statuses'"
            :value="status.value"
          >
          <label :for="`taskStatusFilter-${status.value}-${index}`">{{ status.key }}</label>
        </div>
      </div>
      <div v-else class="filter-settings">
        No statuses available.
      </div>
      <div class="filter-footer">
        <button class="button-text clear-button" @click="clearSelection">Clear Selection</button>
      </div>
    </template>
  </FilterPopper>
</template>

<script setup>
import { computed } from 'vue';
import FilterPopper from '@/components/FilterPopper.vue';
import BaseFilterButton from '@/components/BaseFilterButton.vue';

const props = defineProps({
  statusList: {
    type: Array,
    default: () => [],
  },
  modelValue: {
    type: Array,
    default: () => [],
  },
  label: {
    type: String,
    default: 'Status',
  },
});

const emit = defineEmits(['update:modelValue']);

const selectedStatuses = computed({
  get() {
    return Array.isArray(props.modelValue) ? props.modelValue : [];
  },
  set(value) {
    emit('update:modelValue', Array.isArray(value) ? value : []);
  },
});

const isActive = computed(() => selectedStatuses.value.length > 0);
const tagValue = computed(() => selectedStatuses.value.length.toString());

const clearSelection = () => {
  emit('update:modelValue', []);
};
</script>

<style lang="scss" scoped>
.filter-settings {
  display: flex;
  flex-direction: column;
  padding: 8px;
  border-radius: inherit;
  gap: 6px;
  min-width: 200px;
  overflow: auto;

  &__row {
    display: flex;
    align-items: center;
  }

  & input[type=checkbox] {
    margin-right: 12px;
  }
}

.filter-footer {
  min-height: 38px;
  width: 100%;
  border-top: 1px solid rgba(140,140,140,0.375);
  padding: 8px;
  text-align: center;

  .clear-button {
    text-align: center;
    @include themify() {
      color: themed('color-danger');
    }

    &[disabled] {
      @include themify() {
        color: themed('color-disabled');
      }
    }
  }
}
</style>